import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "self-delivery-list-popup__filters" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Список заказов с пометкой \"Самопривоз\" на", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "по сектору", -1)
const _hoisted_4 = { class: "self-delivery-list-popup__container" }
const _hoisted_5 = {
  key: 0,
  class: "container__statement"
}
const _hoisted_6 = {
  key: 0,
  class: "statement__loading"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-400" }, "Загрузка данных...", -1)
const _hoisted_8 = {
  key: 1,
  class: "statement__failed"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-red-500" }, "При получении данных произошла ошибка", -1)
const _hoisted_10 = {
  key: 1,
  class: "container__content"
}
const _hoisted_11 = { class: "content__table" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Номер заказа"),
    /*#__PURE__*/_createElementVNode("th", null, "Номер накладной"),
    /*#__PURE__*/_createElementVNode("th", null, "Компания"),
    /*#__PURE__*/_createElementVNode("th", null, "Имя отправителя"),
    /*#__PURE__*/_createElementVNode("th", null, "Номер отправителя")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_date = _resolveComponent("dw-date")!
  const _component_dw_select = _resolveComponent("dw-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_dw_button = _resolveComponent("dw-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dw_popup = _resolveComponent("dw-popup")!

  return (_openBlock(), _createBlock(_component_dw_popup, {
    class: "self-delivery-list-popup dw-popup--large",
    title: "Самопривоз",
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", null, [
          _createVNode(_component_dw_date, {
            placeholder: "Выбрать дату",
            bordered: "",
            value: _ctx.state.date,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.date) = $event)),
            disabled: _ctx.dispatcherSectorsLoading || _ctx.state.is_loading,
            onChange: _ctx.loadList
          }, null, 8, ["value", "disabled", "onChange"])
        ]),
        _hoisted_3,
        _createElementVNode("div", null, [
          _createVNode(_component_dw_select, {
            placeholder: "Выбрать сектор диспетчера",
            bordered: "",
            value: _ctx.state.dispatcherSectorId,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.dispatcherSectorId) = $event)),
            disabled: _ctx.dispatcherSectorsLoading || _ctx.state.is_loading,
            loading: _ctx.dispatcherSectorsLoading,
            failed: _ctx.dispatcherSectorsFailed,
            options: _ctx.dispatcherSectors,
            onChange: _ctx.loadList
          }, null, 8, ["value", "disabled", "loading", "failed", "options", "onChange"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_the_button, {
            class: "primary small",
            loading: _ctx.export_state.is_loading,
            disabled: _ctx.export_state.is_loading,
            onClick: _ctx.exportInExcel
          }, {
            default: _withCtx(() => [
              _createTextVNode("Выгрузить в Excel")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.state.is_loading || _ctx.state.is_failed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_component_loader, { class: "primary small" }),
                    _hoisted_7
                  ]))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createVNode(_component_dw_button, {
                        loading: _ctx.state.is_loading,
                        disabled: _ctx.state.is_loading,
                        onClick: _ctx.loadList
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Попробовать еще раз")
                        ]),
                        _: 1
                      }, 8, ["loading", "disabled", "onClick"])
                    ]))
                  : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.invoices, (invoice) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: invoice.invoiceId
                    }, [
                      _createElementVNode("td", null, [
                        (Boolean(invoice.orderNumber))
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/order/${invoice.orderId}`,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(invoice.orderNumber), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" - ")
                            ], 64))
                      ]),
                      _createElementVNode("td", null, [
                        (Boolean(invoice.invoiceNumber))
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/invoice/${invoice.invoiceId}`,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(invoice.invoiceNumber), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" - ")
                            ], 64))
                      ]),
                      _createElementVNode("td", null, [
                        (Boolean(invoice.companyName))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(invoice.companyName), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" - ")
                            ], 64))
                      ]),
                      _createElementVNode("td", null, [
                        (Boolean(invoice.senderName))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(invoice.senderName), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" - ")
                            ], 64))
                      ]),
                      _createElementVNode("td", null, [
                        (Boolean(invoice.senderPhone))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(invoice.senderPhone), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" - ")
                            ], 64))
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}